import { baseURL } from "@/request/http";
import { saveAsFile } from "@/utils/download";
import { apiWeeklyExport } from "@/request/api";
import { ElMessage } from "element-plus";

export default ({ params, total }) => {
    // 导出
    function exportExcel() {
        if (!total.value) {
            ElMessage.error("暂无数据");
            return;
        }
        let herf = baseURL + apiWeeklyExport() + "?";
        const obj = { ...params.value };
        for (const key in obj) {
            const val = obj[key];
            if (Array.isArray(val)) {
                herf += `${key}=${val.join(",")}&`;
            } else {
                herf += `${key}=${obj[key]}&`;
            }
        }
        herf += `token=${localStorage.getItem("token")}`;
        saveAsFile(herf);
    }

    return { exportExcel };
};
